__turbopack_context__.v({
  "arc": "_8QAb0W_arc",
  "colorScheme--high": "_8QAb0W_colorScheme--high",
  "colorScheme--low": "_8QAb0W_colorScheme--low",
  "colorScheme--mid": "_8QAb0W_colorScheme--mid",
  "container": "_8QAb0W_container",
  "decimal": "_8QAb0W_decimal",
  "graphic": "_8QAb0W_graphic",
  "hasDecimal": "_8QAb0W_hasDecimal",
  "is100": "_8QAb0W_is100",
  "isLessThanZero": "_8QAb0W_isLessThanZero",
  "percentSign": "_8QAb0W_percentSign",
  "percentage": "_8QAb0W_percentage",
  "track": "_8QAb0W_track",
  "value": "_8QAb0W_value",
});
